export const isTradeableCard = card => Boolean(card && !card.is_missing && card.status !== "wanted"
  && Number(card.quantity ?? 1) > 0 && Number(card.available_quantity || 0) > 0
  && card.card_intention === "for_trade" && card.availability === "available"
  && card.visibility !== "private");
